import React, {useEffect, useRef, useState} from "react";
import {useNavigate}                        from "react-router-dom";
import {InputText}                          from "primereact/inputtext";
import {Toast}                              from "primereact/toast";
import {Button}                             from "primereact/button";
import {Dropdown}                           from "primereact/dropdown";
import {InputMask}                          from "primereact/inputmask";

import {Token, UsuarioMaster}                       from "../../services/auth";
import {CabecalhoTabela, FundoSistema, TelaSistema} from "../../assets/style";
import Menu                                         from "../../components/menu";
import api, {URLAPI}                                from "../../services/api";
import debug                                        from "../../utils/debug";
import axios                                        from "axios";
import moment                                       from "moment/moment";

const Relatorio = () => {
    const navegacao = useNavigate();
    const aviso = useRef(null);
    const [listaClientes, setListaClientes] = useState([]);

    const endpointAPI = 'cadastro/evento/relatorio';
    const inicial = {idcliente: 0, iniEvento: '', fimEvento: '', participante: '', iniCadastro: '', fimCadastro: ''};
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState(inicial);

    useEffect(() => {
        if (!UsuarioMaster()) {
            navegacao('/sistema');
        } else {
            carregarItens();
        }
    }, []);

    const carregarItens = async () => {
        await new api().requisitar('get', `/cadastro/cliente/combo`).then((resposta) => {
            setListaClientes(resposta ?? []);
        }).catch((erro) => {
            debug(erro);
        });
    };

    const limparTela = () => {
        setItem(inicial);
        carregarItens();
    };

    const aoDigitar = (e, propriedade) => {
        const texto = (e.target && e.target.value) || '';
        let _item = {...item};
        _item[`${propriedade}`] = texto;
        setItem(_item);
    };

    const gerarExcel = async () => {
        try {
            const ei = item.iniEvento;
            const ef = item.fimEvento;
            const ci = item.iniCadastro;
            const cf = item.fimCadastro;
            if (item.iniEvento && !moment(`${item.iniEvento}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "de" do evento inválida!'};
            }
            if (item.iniEvento && !moment(`${item.fimEvento}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "até" do evento inválida!'};
            }
            if (item.iniEvento && item.fimEvento) {
                item.iniEvento = moment(`${item.iniEvento} 00:00`, 'DD/MM/YYYY HH:mm');
                item.fimEvento = moment(`${item.fimEvento} 23:59`, 'DD/MM/YYYY HH:mm');
            }

            if (item.iniCadastro && !moment(`${item.iniCadastro}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "de" da incrição inválida!'};
            }
            if (item.iniCadastro && !moment(`${item.fimCadastro}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "até" da incrição inválida!'};
            }
            if (item.iniCadastro && item.fimCadastro) {
                item.iniCadastro = moment(`${item.iniCadastro} 00:00`, 'DD/MM/YYYY HH:mm');
                item.fimCadastro = moment(`${item.fimCadastro} 23:59`, 'DD/MM/YYYY HH:mm');
            }

            const response = await axios.post(`${process.env.REACT_APP_URLAPI}/${endpointAPI}-xls`, item, {responseType: 'blob', headers: {'Authorization': `Bearer ${Token()}`}});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = 'relatorio.xlsx';
            link.setAttribute('relatorio', 'relatorio.xlsx'); // Define o nome do arquivo
            document.body.appendChild(link);
            link.click();

            // Limpa o link temporário
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
            item.iniCadastro = ci;
            item.fimCadastro = cf;
            item.iniEvento = ei;
            item.fimEvento = ef;
        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }
    }
    const gerarPdf = async () => {
        try {
            if (item.iniEvento && !moment(`${item.iniEvento}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "de" do evento inválida!'};
            }
            if (item.fimEvento && !moment(`${item.fimEvento}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "até" do evento inválida!'};
            }
            if (item.iniCadastro && !moment(`${item.iniCadastro}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "de" da incrição inválida!'};
            }
            if (item.fimCadastro && !moment(`${item.fimCadastro}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data "até" da incrição inválida!'};
            }

            const response = await axios.post(`${process.env.REACT_APP_URLAPI}/${endpointAPI}-pdf`, item, {responseType: 'blob', headers: {'Authorization': `Bearer ${Token()}`}});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = 'relatorio.pdf';
            link.setAttribute('relatorio', 'relatorio.pdf'); // Define o nome do arquivo
            document.body.appendChild(link);
            link.click();

            // Limpa o link temporário
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }

        /*try {
         await new api().requisitar('post', `${endpointAPI}-pdf`, item).then((resposta) => {
         window.open(`${URLAPI}/download/${resposta}`, '_blank');
         }).catch((erro) => {
         throw {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
         });
         } catch (erro) {
         aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
         }*/
    }

    return (
        <FundoSistema>
            <Menu/>
            <Toast ref={aviso}></Toast>
            <TelaSistema title='Relatório Geral'>
                <div className='grid'>
                    {UsuarioMaster() &&
                     <div className="field col-12 md:col-6">
                         <label htmlFor="idcliente">Cliente</label><br/>
                         <Dropdown className="w-full" autoComplete="none" id="idcliente" value={item?.idcliente} options={listaClientes} onChange={(e) => aoDigitar(e, 'idcliente')} optionLabel="valor" optionValue="id" required/>
                     </div>
                    }
                    <div className="field col-12 md:col-3">
                        <label htmlFor="nome">Data do Evento </label><br/>
                        <span className="mr-2">de</span>
                        <InputMask id="dia" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.iniEvento} onChange={(e) => aoDigitar(e, 'iniEvento')}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="nome">Data do Evento </label><br/>
                        <span className="mr-2">até:</span>
                        <InputMask id="dia" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.fimEvento} onChange={(e) => aoDigitar(e, 'fimEvento')}/>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="participante">Nome do participante</label><br/>
                        <InputText className="w-full" autoComplete="none" id="participante" maxLength={255} value={item.participante} onChange={(e) => aoDigitar(e, 'participante')} required/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="nome">Data de inscrição </label><br/>
                        <span className="mr-2">de</span>
                        <InputMask id="dia" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.iniCadastro} onChange={(e) => aoDigitar(e, 'iniCadastro')}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="nome">Data de inscrição </label><br/>
                        <span className="mr-2">até</span>
                        <InputMask id="dia" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.fimCadastro} onChange={(e) => aoDigitar(e, 'fimCadastro')}/>
                    </div>
                    <div className="field centralizado col-12">
                        <div style={{textAlign: 'center'}}>
                            <Button icon={"pi pi-file-excel"} severity="info" label="Relatório em Excel" className="mr-2 center-align" onClick={gerarExcel}/>
                            <Button icon={"pi pi-file-pdf"} severity="info" label="Relatório em PDF" className="center-align" onClick={gerarPdf}/>
                        </div>
                    </div>
                </div>
            </TelaSistema>
        </FundoSistema>
    );
}

export default Relatorio;